<template>
  <div>
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <header>
      <div class="header-container">
        <div class="logo-flex-item">
          <img class="logo-image" src="../../assets/logo.png" @click="$router.push('/home');" alt="The Death Rosenstock Sanctuary">
        </div>
        <!--div class="icons-flex-container">
          <svg class="header-icon" width="160" height="154" viewBox="0 0 160 154" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
              <path d="M36.73 101.022C47.6036 102.903 58.4481 102.055 69.8857 98.429C76.5559 96.3644 82.9172 93.4005 88.7963 89.6197C89.9022 90.855 90.997 92.0837 92.0808 93.3066C94.7416 96.3037 97.2603 99.1351 99.8939 101.976C112.764 115.861 126.727 129.064 140.231 141.832C142.685 144.154 145.138 146.477 147.59 148.801C149.512 150.565 151.623 152.107 153.885 153.399C154.443 153.698 155.07 153.846 155.702 153.827C156.364 153.837 157.019 153.699 157.621 153.422C157.947 153.258 158.236 153.029 158.473 152.749C158.709 152.47 158.887 152.146 158.997 151.796C159.126 151.38 159.173 150.942 159.133 150.506C159.094 150.072 158.97 149.65 158.769 149.263C157.7 147.016 156.395 144.891 154.875 142.925C152.425 140.004 149.819 137.218 147.068 134.581C140.66 128.347 134.119 122.039 127.793 115.937C123.406 111.708 119.023 107.475 114.643 103.238C110.121 98.8597 105.718 94.5588 101.057 89.9988C99.1592 88.143 97.2486 86.2767 95.3264 84.4L95.5756 84.1253C95.9377 83.7272 96.2187 83.4179 96.5179 83.1262C103.803 76.0331 107.798 67.1592 108.39 56.7533C109.42 38.6831 103.361 23.3432 90.3863 11.1543C84.0296 5.04049 75.783 1.29956 67.0179 0.553903C58.4932 -0.270596 49.8914 0.711922 41.768 3.43809C29.314 7.69659 18.7422 15.8664 10.3477 27.7211C3.11482 37.9347 0.215761 49.2675 1.73113 61.4047C2.71952 69.3243 5.90734 76.8292 12.0662 85.7403C17.8862 94.1575 25.9524 99.156 36.73 101.022ZM49.609 12.7583C52.506 12.511 55.5017 12.2559 58.4435 12.158C58.942 12.1424 59.4356 12.1343 59.9245 12.1338C73.3337 12.1338 83.6376 18.2501 90.5667 30.3293C96.7684 41.138 98.5226 51.4965 95.9312 61.9959C95.0427 65.9331 93.2691 69.6134 90.7459 72.7534C87.6145 76.5819 83.8089 79.797 79.5185 82.2381C69.7235 87.8291 58.7062 90.9019 47.4459 91.1838C46.366 91.0638 45.2835 90.9574 44.201 90.851C41.8154 90.6174 39.348 90.3747 36.9578 89.9825C31.0166 89.082 25.618 85.9994 21.8041 81.3311C17.1561 75.8798 13.8004 69.4379 11.9902 62.4919C9.91428 54.4407 10.6709 45.9153 14.1319 38.3609C17.9959 29.7323 23.128 23.366 29.8223 18.8987C35.1789 15.3247 40.0625 13.4866 45.1894 13.116C46.6633 13.0096 48.1345 12.8836 49.6064 12.7583H49.609Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="159" height="154" transform="translate(0.777344)"/>
              </clipPath>
            </defs>
          </svg>
          <svg class="header-icon" width="71" height="134" viewBox="0 0 71 134" fill="white" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
            <path d="M2.51619 19.4153C4.86379 20.8581 6.37293 19.1636 7.47475 17.9244L7.57923 17.806C10.984 13.9844 15.5254 11.6472 22.3031 10.2252C32.7337 8.0409 41.5479 9.75168 49.255 15.4577C58.9053 22.6046 64.0439 37.6094 55.5168 49.3877C53.2338 52.454 50.5274 55.1786 47.4795 57.4797C43.6419 60.4492 39.5552 63.2438 35.6034 65.9466C34.0407 67.016 32.4775 68.0841 30.9252 69.1658C24.4434 73.5195 19.8762 80.2059 18.1667 87.8432C17.4155 91.1204 16.9484 94.4261 16.4552 97.9258C16.229 99.5227 16.0013 101.152 15.7355 102.821C15.7261 102.886 15.7261 102.951 15.7355 103.016C15.8178 103.602 15.8863 104.221 15.9576 104.863C16.1043 106.55 16.3784 108.222 16.778 109.867C17.3685 112.058 19.2078 113.405 21.6973 113.468H21.8676C22.9291 113.502 23.975 113.206 24.8627 112.622C25.7505 112.036 26.437 111.19 26.8274 110.199C27.4613 108.602 27.8738 106.926 28.0541 105.216C28.2835 103.395 28.4602 101.548 28.632 99.7582C28.8666 97.3052 29.1099 94.769 29.489 92.3056C29.8601 89.6269 30.7753 87.0529 32.1778 84.7437C33.5804 82.4344 35.4404 80.4388 37.6428 78.8808C38.9132 77.9565 40.2008 77.0549 41.4887 76.1534C43.8952 74.4692 46.3843 72.7279 48.717 70.8525L49.2734 70.4063C53.3697 67.1155 57.6047 63.7128 61.2875 59.8684C66.4201 54.6118 69.5196 47.692 70.029 40.3499C70.9889 26.289 65.5498 15.1559 53.8604 7.26032C40.8028 -1.55897 26.5309 -2.08262 10.2326 5.66467C6.79979 7.35614 3.94224 10.0287 2.01932 13.3462C0.564877 15.7413 0.777211 18.3433 2.51619 19.4153Z" fill="white"/>
            <path d="M23.8226 118.717C21.558 118.708 19.7396 119.327 18.4912 120.574C17.2293 121.831 16.588 123.651 16.5854 125.985C16.5722 127.104 16.7812 128.215 17.2 129.252C17.6189 130.289 18.2397 131.232 19.0254 132.026C20.2667 133.27 21.9454 133.974 23.6992 133.986C23.7576 133.986 23.8149 133.986 23.8726 133.986C27.5898 133.886 31.0763 130.179 31.1871 126.209C31.216 125.248 31.0519 124.291 30.7042 123.395C30.3564 122.499 29.832 121.682 29.1629 120.994C28.4708 120.274 27.641 119.701 26.7235 119.309C25.806 118.919 24.8195 118.717 23.8226 118.717Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0">
            <rect width="70" height="134" fill="white" transform="translate(0.777344)"/>
            </clipPath>
            </defs>
          </svg>
        </div-->
      </div>
    </header>
  </div>
</template>

<script>
  export default {
    name: 'Header'
  }
</script>

<style>
  .header-container {
    display: flex;
    justify-content: space-between;
    margin: .5em;
  }

  .logo-flex-item {
    margin-left: 1em;
    margin-top: 1em;
  }

  .icons-flex-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 2em;
  }

  .header-icon {
    max-height: 6vh;
  }

  .logo-image {
    max-height: 20vh;
    cursor: pointer;
  }
  .logo-image:hover {
    cursor: pointer;
  }

  .logo-image.small {
    max-height: 13vh;
  }

  @media (min-width:320px) {
    .logo-image {
      max-height: 9vh;
    }
    .logo-image.small {
      max-height: 9vh;
    }
    .header-icon {
      max-height: 6vh;
    }
  }

  @media (min-width:481px) {
    .logo-image {
      max-height: 9vh;
    }
    .logo-image.small {
      max-height: 9vh;
    }
    .header-icon {
      max-height: 6vh;
    }
  }

  @media (min-width:767px) {
    .logo-image {
      max-height: 16vh;
    }
    .logo-image.small {
      max-height: 13vh;
    }
  }

  @media (min-width:1025px) {
    .logo-image {
      max-height: 20vh;
    }
    .logo-image.small {
      max-height: 13vh;
    }
  }

  @media (min-width:1281px) {
    .logo-image {
      max-height: 20vh;
    }
    .logo-image.small {
      max-height: 13vh;
    }
  }

</style>